export default __webpack_public_path__ + "static/media/02.4-green-bites.07fd67a2.png";